import {ActionIcon, Indicator} from '@mantine/core';
import {FC, forwardRef} from 'react';
import clsx from 'clsx';
import {useMediaQuery} from '@mantine/hooks';

import Icon, {Icons} from '~/common/Icon';

import s from '../styles.module.scss';

interface NotificationButtonProps {
  onClick: () => void;
  count: number;
  className?: string;
}

const NotificationButton: FC<NotificationButtonProps> = forwardRef(
  ({onClick, count, className}, ref) => {
    const isMobile = useMediaQuery('(max-width: 767px)');

    const button = (
      <ActionIcon
        variant="default"
        className={clsx(s['notifications-button'], className)}
        ref={ref as any}
        onClick={onClick}
      >
        <Icon name={Icons.notificationBell} />
      </ActionIcon>
    );

    if (count === 0) {
      return button;
    }

    return (
      <Indicator
        label={count}
        size={isMobile ? 19 : 23}
        color="#F90"
        offset={5}
        zIndex={1050}
        classNames={{
          indicator: s['notifications-button__indicator'],
        }}
      >
        {button}
      </Indicator>
    );
  }
);

export default NotificationButton;
